// NPM
/* Load npm scripts here */

// VENDOR
/* Load vendor modules here */

// BUNDLES
/* Load bundles here */
import defaultBundle from 'bundles/default.bundle';

// HELPERS
/* Load helpers here */
import { CustomerMobileMenu } from 'helpers/customer-service/mobile-menu/mobileMenu';

// COMPONENTS
/* Load components here */
import { initResendActivation } from 'components/alert/alert';

// PAGE
/* load page specific scripts */
import { loginFormValidation } from './partials/loginForm';

// init the default bundle
defaultBundle();

initResendActivation();
loginFormValidation();
CustomerMobileMenu.init();
